import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel"
import { cn } from "@/lib/utils"
import parse from "html-react-parser"
import classes from "./announcementsList.module.css"

const AnnouncementsList = (props) => {
  const { data } = props

  if (data.length === 0) {
    return null
  }

  return (
    <div className={classes.root}>
      <Carousel
        opts={{
          align: "start",
          loop: true,
        }}
        className={cn(
          "mx-auto line-clamp-1 w-full max-w-[90vw] lg_max-w-[700px]"
        )}
        autoPlay={true}
        interval={5000}
      >
        <CarouselContent>
          {data.map((item) => (
            <CarouselItem key={item.id}>
              <div className="text-center font-sans text-sm uppercase">
                {parse(item.content)}
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="-left-2 hidden border-transparent bg-transparent text-white hover_bg-transparent lg_left-12 lg_block" />
        <CarouselNext className="-right-2 hidden border-transparent bg-transparent text-white hover_bg-transparent  lg_right-12 lg_block" />
      </Carousel>
    </div>
  )
}

export default AnnouncementsList
